import {
  Component,
  ChangeDetectionStrategy,
  Input,
  ChangeDetectorRef
} from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { OptionAfterschoolComponentInReply } from '../../../../reply';
import { ReplyItem } from '../../../../../classes';
import { ReplyService, AuthService, TransactionService, RepliesService } from '../../../../../services';

@Component({
  selector: 'option-afterschool',
  styleUrls: ['./option-afterschool.component.scss'],
  templateUrl: './option-afterschool.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OptionAfterschoolComponent extends OptionAfterschoolComponentInReply {
  @Input() item: ReplyItem;
  constructor(
    reply: ReplyService,
    auth: AuthService,
    transaction: TransactionService,
    db: AngularFireDatabase,
    cdRef: ChangeDetectorRef,
    private repliesService: RepliesService
  ) {
    super(reply, auth, transaction, db, cdRef);
  }
  ngOnInit() {
    this.as = this.item.as;
    this.reply.tracker.set([this.item.as], this.item.snapshot);
    super.ngOnInit();
  }

  get checked(): boolean {
    const forged = this.repliesService.forgeGet(this.item);
    if (forged) {
      const forgedCheck = forged.get(this.option);
      if (forgedCheck) return forgedCheck.value !== null ? true : false;
    } else {
      return ['reserved', 'confirmed', 'static'].includes(this.checkStatus);
    }
  }

  toggleCheck() {
    const checking = !this.checked;
    this.repliesService.forgeSet(
      this.item,
      this.option,
      checking ? true : null
    );
  }
}
